module.exports = __webpack_public_path__ + "img/3.0799f1bf.jpg";